{ Analytics } = require '@trello/atlassian-analytics'
{ getSeparatorClassName } = require 'app/scripts/views/card/SeparatorCard/SeparatorCard'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
t = require('app/scripts/views/internal/teacup-with-helpers')('card_aging')
View = require 'app/scripts/views/internal/view'

CARD_AGING_POWER_UP_ID = require('app/scripts/data/legacy-power-ups').cardAging

template = t.renderable ({ evergreen }) ->
  t.ul '.pop-over-list', ->
    t.li ->
      t.a '.js-toggle-ignore', { href: '#' }, ->
        t.span '.name', ->
          t.format 'evergreen'
          if evergreen
            t.icon 'check'
        t.span '.sub-name', ->
          t.format 'evergreen cards'

module.exports = class CardAgingPopoverView extends View
  viewTitleKey: 'card aging'

  initialize: ->
    @getEvergreenData()
    @subscribe pluginsChangedSignal(@model.getBoard(), @model), =>
      @render()

  events:
    'click .js-toggle-ignore': 'toggleIgnore'

  getEvergreenData: ->
    pluginData = @model.getPluginData(CARD_AGING_POWER_UP_ID)
    if typeof pluginData?.card?.shared == 'string'
      @evergreen = JSON.parse(pluginData.card.shared).evergreen

  toggleIgnore: ->
    @model.setPluginData(
      CARD_AGING_POWER_UP_ID,
      'shared',
      JSON.stringify(evergreen: !@evergreen)
    )
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'button'
      actionSubjectId: 'cardAgingEvergreenButton'
      containers:
        board:
          id: @model.getBoard().id
        card:
          id: @model.id
      attributes:
        isEvergreenAfterClick: @evergreen
        isTemplate: @model.get('isTemplate')
        separatorType: getSeparatorClassName(@model.get('name'))
      source: 'cardDetailScreen'
    @render()

  render: ->
    @getEvergreenData()
    @$el.html template ({ evergreen: @evergreen })
    @